import React, { useState } from 'react';
import { Bot, Sparkles, Send, Copy, Check } from 'lucide-react';

export const AICopilotModule: React.FC = () => {
  const [prompt, setPrompt] = useState('');
  const [response, setResponse] = useState('');
  const [generating, setGenerating] = useState(false);

  const handleGenerate = (e: React.FormEvent) => {
    e.preventDefault();
    if (!prompt) return;
    setGenerating(true);
    setResponse('');
    setTimeout(() => {
      setGenerating(false);
      setResponse(
        `🤖 AI Copilot Draft:\n\n` +
        `Goal Statement: "By December 2026, when presented with a 12-icon AAC board, the student will independently construct a 3-word sentence (e.g., 'I want water') with 80% accuracy across 4 out of 5 consecutive sessions as measured by clinical observation logs."\n\n` +
        `Suggested Accommodations:\n` +
        `1. Provide high-contrast color coding for verb symbols.\n` +
        `2. Allow 5-second processing time prior to verbal prompt.`
      );
    }, 1200);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-pink-100 text-pink-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Claude Health & MentalSHIELD Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">AI Copilot & Clinical Report Summarizer</h2>
          <p className="text-xs text-slate-500">Automated SMART IEP goal drafting, progress note summarizing, and risk detection</p>
        </div>
      </div>

      <div className="space-y-4">
        <form onSubmit={handleGenerate} className="flex gap-2">
          <input
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Ask AI Copilot (e.g. 'Draft SMART IEP goal for non-verbal student using AAC board')..."
            className="flex-1 px-4 py-2.5 border border-slate-300 rounded-xl text-xs focus:ring-2 focus:ring-pink-500 focus:outline-none"
          />
          <button
            type="submit"
            disabled={generating}
            className="px-6 py-2.5 bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-xl text-xs flex items-center gap-2 transition"
          >
            <Sparkles className="w-4 h-4 text-amber-300" />
            {generating ? 'Drafting...' : 'Generate with AI'}
          </button>
        </form>

        {response && (
          <div className="bg-slate-900 text-slate-100 p-4 rounded-xl text-xs space-y-2 font-mono whitespace-pre-wrap border border-slate-800 shadow-inner">
            <div className="flex justify-between items-center text-slate-400 font-sans border-b border-slate-800 pb-2">
              <span className="flex items-center gap-1.5 text-pink-400 font-bold">
                <Bot className="w-4 h-4" />
                AI Copilot Response
              </span>
            </div>
            <div>{response}</div>
          </div>
        )}
      </div>
    </div>
  );
};
